import "./table-scroll";
import "./login-register";
// import "./change-text-form-login";
// import "./edit-adress-placeholder";
import "./password-toggle";
import "./edit-account";
import "./popup-register";
import "./addressen-active";
import "./onClickInARow";
// import "./check-tel-input";
import "./foldable-change-password";
import "./request-new-password";
import "./content-scroll";
import "./forget-password";
import "./forget-password-save";
